import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[650px] md:h-[800px] flex items-center justify-center bg-[#f4f5f7] overflow-hidden">
      
      {/* 1. 图片层：(建议保留上一轮说的 object-cover，让它铺满无断层) */}
      <motion.div
         initial={{ opacity: 0, y: 30 }}
         animate={{ opacity: 1, y: 0 }}
         transition={{ duration: 0.8, delay: 0.2 }}
         className="absolute inset-0 w-full h-full z-0 flex items-center justify-center"
      >
         <img
           src={t('hero.imagePath')}
           alt="Hero Product Banner"
           className="w-full h-full object-cover pointer-events-none" 
         />
      </motion.div>

      {/* 2. 文字层：终极居中方案 */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        // 【关键修复 1】：必须加上 w-full，强迫这个隐形的容器横跨 100% 的屏幕宽度
        className="relative z-10 w-full px-4 flex flex-col items-center justify-center"
      >
        {/* 【关键修复 2】：为 h1 和 p 显式添加 w-full、mx-auto 和 text-center */}
        {/* 【关键修复 3】：务必确保这里没有 whitespace-nowrap 这个词了！ */}
        <h1 className="w-full max-w-5xl mx-auto text-center text-[clamp(32px,5vw,72px)] font-extrabold text-black tracking-widest mb-4 md:mb-6 drop-shadow-sm leading-tight">
          {t('hero.title')}
        </h1>
        
        <p className="w-full max-w-2xl mx-auto text-center text-[clamp(16px,2vw,24px)] text-gray-700 tracking-wide drop-shadow-sm">
          {t('hero.subtitle')}
        </p>
      </motion.div>

    </section>
  );
}